/* eslint-disable */

import roles from './roles/state'
import users from './users/state'
import appManagement from './appManagement/state'
import documentManager from './documentManager/state'
import uiManagement from './uiManagement/state'
import settings from './settings/state'
import notifications from './notificationSettings/state'
import mktComponents from './mktComponents/state'
import mktApps from './mktApps/state'
import processInstance from './processInspector/state'
import labs from './labs/state'

export default {
  ...roles,
  ...users,
  ...appManagement,
  ...documentManager,
  ...uiManagement,
  ...settings,
  ...notifications,
  ...mktComponents,
  ...mktApps,
  ...processInstance,
  ...labs,
}